module.exports = __webpack_public_path__ + "static/media/List_BOOK.664ce90e.mp3";